export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14791.2db68eb0.jpg";